function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesMap from '@domain-group/fe-co-allhomes-map';
import { withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import FooterCard from './footer-card';
import AllhomesAgencyModel from './agency-model';
import * as styles from './agency-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var defaultZoom = 16;
var scrollTarget = 'agency-profile-page-footer-scroll-target';
class AllhomesAgencyFooter extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleMapActivity", () => {
      if (!this.state.mapActivitySent) {
        this.props.sendEvent('map-activity');
        this.setState({
          mapActivitySent: true
        });
      }
    });
    _defineProperty(this, "onWebsiteClicked", () => {
      this.props.sendEvent('website-click');
    });
    _defineProperty(this, "footerCardEnquiryCallback", () => {
      this.props.sendEvent('email-click');
      var profile = this.props.profile;
      this.props.enquiryFormCallback({
        email: profile.email,
        id: profile.id,
        title: "Contact ".concat(profile.name),
        logo: profile.images.profilePhoto ? profile.images.profilePhoto : '',
        type: 'AGENCY',
        source: 'Footer'
      });
    });
    this.state = {
      zoomLevel: this.props.profile.address.zoomLevel || defaultZoom,
      coords: {
        lat: this.props.profile.address.lat,
        lng: this.props.profile.address.lng
      },
      mapActivitySent: false
    };
  }
  componentDidMount() {
    var request = {
      street: this.props.profile.address.street,
      suburb: this.props.profile.address.suburb,
      state: this.props.profile.address.state,
      postcode: this.props.profile.address.postcode
    };
    var geocoderQueryUrl = "".concat(this.props.geocoderEndpoint, "?").concat(new URLSearchParams(request));
    fetch(geocoderQueryUrl).then(response => {
      if (response.ok) {
        return response.json();
      }
      return false;
    }).then(data => {
      if (data !== null && data !== void 0 && data.lat) {
        this.setState({
          zoomLevel: data.zoomLevel,
          coords: {
            lat: data.lat,
            lng: data.lng
          }
        });
      }
    }).catch(() => {});
  }
  render() {
    return ___EmotionJSX("div", {
      id: scrollTarget,
      css: styles.footer
    }, ___EmotionJSX("div", {
      css: styles.map
    }, this.props.googleMapsParams && ___EmotionJSX(AllhomesMap, {
      coords: this.state.coords,
      zoom: this.state.zoomLevel,
      googleMapsParams: this.props.googleMapsParams,
      onRightClick: this.handleMapActivity,
      onMarkerClick: this.handleMapActivity,
      onMapClick: this.handleMapActivity,
      onDragEnd: this.handleMapActivity,
      onMapTypeIdChanged: this.handleMapActivity
    })), ___EmotionJSX(FooterCard, _extends({}, this.props.profile, {
      css: styles.footerCard,
      eventHandlers: {
        websiteClicked: this.onWebsiteClicked,
        contactClicked: this.footerCardEnquiryCallback
      }
    })));
  }
}
AllhomesAgencyFooter.propTypes = {
  profile: PropTypes.shape(AllhomesAgencyModel),
  enquiryFormCallback: PropTypes.func.isRequired,
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  geocoderEndpoint: PropTypes.string.isRequired,
  sendEvent: PropTypes.func
};
AllhomesAgencyFooter.defaultProps = {
  profile: {},
  sendEvent: () => {}
};
export { AllhomesAgencyFooter as BaseAllhomesAgencyFooter, scrollTarget };
export default withSendEvent(AllhomesAgencyFooter);